import React, { Component } from 'react';
import WordColourPickerSlider from './WordColourPickerSlider.js'
import { observer } from 'mobx-react';
import JsonTable from './JsonTable.js';
import ColourPickerModalWrapper from './ColourPickerModal.js';

@observer
class WordColourPicker extends Component {

    constructor(props) {
        super(props);

        this.canvasRef = React.createRef();
        this.sliderWidgetRef = React.createRef();
        console.log('construct');
        this.state = {
            canvas: null,
            colourPickerOpen: false,
            selectedLetter: -1,
        };
    }

    handleModalColorReset = () => {
        const newSettings = this.props.letterSettings;
        const selectedLetter = this.state.selectedLetter;
        newSettings[selectedLetter].hex = null;
        newSettings[selectedLetter].rgb = {r: 0,g: 0,b: 0};
        newSettings[selectedLetter].leftStrength = 0.25;
        newSettings[selectedLetter].rightStrength = 0.25;

        this.props.onChange(newSettings);
        this.setState({colourPickerOpen: false, selectedLetter: -1});
    }

    handleModalColorClose = (colour, success) => {

        if (success) {
            const newSettings = this.props.letterSettings;
            const selectedLetter = this.state.selectedLetter;
            newSettings[selectedLetter].hex = colour;
            this.props.onChange(newSettings)
        }

        this.setState({colourPickerOpen: false, selectedLetter: -1});
    };


    componentDidMount() {
        console.log('mount');
        if (this.state.canvas == null) {
            console.log('set canvas state');
            const canvas = this.canvasRef.current;
            this.setState({canvas: canvas});// Triggers redraw
        }
    }


    getActiveLetters() {

        const {word, letterSettings, letterColours} = this.props;

        const activeLetters = [];
        for (let i = 0; i < letterSettings.length; i += 1) {

                const letterSetting = letterSettings[i];
                const centrePoint = (i + 0.5) / word.length;
                const leftStr = centrePoint - (letterSettings[i].leftStrength / word.length);
                const rightStr = centrePoint + (letterSettings[i].rightStrength / word.length);

                // if colour specified, use that, otherwise use default
                const hex = letterSetting.hex !== null ? letterSetting.hex : letterColours[letterSetting.letter];

                activeLetters.push({
                    centrePoint: centrePoint,
                    letterIndex: i,
                    letter: letterSettings[i].letter,
                    leftStrength: letterSettings[i].leftStrength,
                    rightStrength: letterSettings[i].rightStrength,
                    active: (letterSettings[i].leftStrength > 0 || letterSettings[i].rightStrength > 0),
                    leftPoint: Math.max(leftStr, 0),
                    rightPoint: Math.min(rightStr, 1),
                    hex: hex
                })


        }


        return activeLetters;
    }

    createGradient(patternWidth, ctx, activeLetters) {

        let gradient = ctx.createLinearGradient(0, 0, patternWidth, 0);

        //let debugStr = '';

        for (let i = 0; i < activeLetters.length; i += 1) {

            if (activeLetters[i].active) {

                const hex = activeLetters[i].hex || '#f0f0f0';

                gradient.addColorStop(activeLetters[i].leftPoint, hex);
                gradient.addColorStop(activeLetters[i].rightPoint, hex);
                //debugStr += ' ' + activeLetters[i].letter + '- ' + activeLetters[i].leftPoint + ' ' + activeLetters[i].rightPoint;
            }
        }
        //console.log(debugStr);
        return gradient;
    }

    pixelsToWordLength(p) {
        return p / this.state.letterWidth;
    }

    wordLengthToPixels(w) {
        return w * this.state.letterWidth;
    }


    getColorPickerColor() {
        const {selectedLetter} = this.state;
        var color = '#000000';
        if (selectedLetter > -1 && selectedLetter < this.props.letterSettings.length) {
            color = this.props.letterSettings[selectedLetter].hex;
            console.log('hi');
        }

        if (color === null) {
            color = this.props.letterColours[this.props.letterSettings[selectedLetter].letter]; //For unset colours set default as no colour
        }

        return color;
    }

    sliderClicked = (event, index) => {
        if (!this.props.canEdit) return;
        const showPopover = !this.state.colourPickerOpen;

        this.setState({
            selectedLetter: showPopover ? index : -1,
            colourPickerOpen: showPopover
        });
    };

    sliderChanged = (event,value,widget,index) => {

        if (!this.props.canEdit) return;

        const letter = this.props.letterSettings[index];
        const centreWord = (index + 0.5) ;
        const newPosition = (value / this.letterWidth);
        const newLetters = this.props.letterSettings;

        let newLeft, newRight;

        if (widget === 'left') {
            newLeft = Math.max(Math.min(centreWord - newPosition), 0);
            newRight = letter.rightStrength;
            newLetters[index].leftStrength = newLeft;
        } else if (widget === 'right') {
            newLeft = letter.leftStrength;
            newRight = Math.max(Math.min(newPosition - centreWord),0);
            newLetters[index].rightStrength = newRight;
        }


        // Move right handles, if need be
        let leftAbsolutePosition = index  - newLeft;
        for (let i = 0; i < (index) ; i += 1) {

            let rightOffset = i + newLetters[i].rightStrength;
            if (leftAbsolutePosition < rightOffset) {
                let newRightOffset = leftAbsolutePosition - i;
                newLetters[i].rightStrength = newRightOffset > 0 ? newRightOffset : 0;
            }

            // Reset strength if crosses centre
            if (leftAbsolutePosition < i) {
                newLetters[i].leftStrength = 0;
                newLetters[i].rightStrength = 0;
            }
        }

        // Move left handles, if need be
        let rightAbsolutePosition = index  + newRight;
        for (let i = index + 1; i < (newLetters.length) ; i += 1) {

            let leftOffset = i - newLetters[i].leftStrength;
            if (rightAbsolutePosition > leftOffset) {
                let newLeftOffset = i - rightAbsolutePosition;
                console.log(newLeftOffset);
                newLetters[i].leftStrength = newLeftOffset > 0 ? newLeftOffset : 0;
            }

            // Reset strength if crosses centre
            if (rightAbsolutePosition > i) {
                newLetters[i].leftStrength = 0;
                newLetters[i].rightStrength = 0;
            }
        }

        this.props.onChange(newLetters);

    };

    getSliderWidgetRef = () => {
        return this.sliderWidgetRef.current;
    };

    render() {
        console.log('render');
        const {canvas, colourPickerOpen } = this.state;
        const {fontSize, word} = this.props;

    // These are overwritten once the canvas is made
        let wordWidth = 100;
        let activeLetters = this.getActiveLetters()

        // Nothing is drawn on canvas, on initial render, until componentDidMount has been run
        if (canvas !== null) {
            console.log('render with canvas');
            // Get context and word width
            const ctx = canvas.getContext("2d");
            ctx.font = fontSize + "px 'Lucida Console', Monaco, monospace";

            // Set word width
            wordWidth = ctx.measureText(word).width;

            // Clear and resize canvas
            canvas.width = Math.ceil(wordWidth);
            canvas.height = fontSize + 30;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.rect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = '#f0f0f0';
            ctx.fill();

            // Shadow
            ctx.shadowColor="#e0e0e0";
            ctx.shadowBlur=8;

            // Get fill gradient
            ctx.fillStyle = this.createGradient(wordWidth, ctx,activeLetters);

            // Draw word and gradient bar
            ctx.font = fontSize + "px 'Lucida Console', Monaco, monospace";
            ctx.fillText(word, 0, fontSize);
            ctx.fillRect(0, fontSize + 10, wordWidth, 20);
        }


        const canvasWidth = Math.ceil(wordWidth);
        const canvasHeight = this.props.fontSize + 30;

        const styles = {
            colourPickerSlider: {
                height: 30,
                position: 'relative',
                display:'inline-block',
                width: canvasWidth
            },
            wordCanvas: {
                width: canvasWidth,
                height: canvasHeight
            }
        };

        //store wordwidth and letterWidth
        this.wordWidth = wordWidth;
        this.letterWidth = wordWidth / word.length;

        // produce representation of data
        let jsonRep = [];
        for (var i = 0; i < activeLetters.length; i += 1) {

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(activeLetters[i].hex);

            let colour;
            if (result) {
                colour = {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16),
                }
            } else {
                colour = {
                    r: '',
                    g: '',
                    b: '',
                }
            }

            jsonRep.push({
                word: word,
                letter: activeLetters[i].letter,
                order: activeLetters[i].letterIndex,
                active: activeLetters[i].active ? '1' : '0',
                r: colour.r,
                g: colour.g,
                b: colour.b,
                lStr:activeLetters[i].leftStrength.toFixed(2),
                rStr: activeLetters[i].rightStrength.toFixed(2)
            })
        }

        console.log(jsonRep);


        let colour = this.getColorPickerColor();

        return (
            <div>
            <canvas ref={this.canvasRef} style={styles.wordCanvas} /><br/>
                <div className="colour-picker-slider" style={styles.colourPickerSlider} ref={this.sliderWidgetRef}>
                    {activeLetters.map((letter,i) => {
                        return (<WordColourPickerSlider key={i}
                                                        letter={letter}
                                                        wordWidth={wordWidth}
                                                        onClick={this.sliderClicked}
                                                        onChange={this.sliderChanged}
                                                        getSliderWidgetRef={this.getSliderWidgetRef}/>)
                    })}

                </div><br/>

                <ColourPickerModalWrapper
                    onClickReset={this.handleModalColorReset}
                    colour={colour}
                    open={colourPickerOpen}
                    modalClose={this.handleModalColorClose}
                 />
                

            </div>
        )

    }


}

export default WordColourPicker;
